// Research: why now, then everything we learned about the company grouped This week / Last 30
// days / Earlier, with a source filter. The Clay engine's read is rows in the same feed.
import { useState } from 'react';
import type { BookAccount } from '../api/types';
import type { WorkReason } from '../book/derived';
import { WorkReasonView } from '../book/WorkReasonView';
import { PanelSection } from './panelParts';
import { groupResearch, researchItems, researchSources } from './researchFeed';
import { scoutFactLine } from './scoutLine';
import { LinkedText } from '../components/LinkedText';
import { firstLinkIn } from './overviewSource';

const ALL_SOURCES = 'all';

export function ResearchTab({ row, today, workReason }: { row: BookAccount; today: string; workReason?: WorkReason | null }) {
  const [source, setSource] = useState(ALL_SOURCES);
  const items = researchItems(row);
  const sources = researchSources(items);
  const shown = source === ALL_SOURCES ? items : items.filter(item => item.source === source);
  const groups = groupResearch(shown, today);
  const assessment = scoutFactLine(row);

  return (
    <>
      {assessment ? <p className="researchassessment">{assessment}</p> : null}
      {workReason ? <PanelSection title="Why now"><WorkReasonView reason={workReason} /></PanelSection> : null}

      {items.length ? (
        <>
          <div className="researchfilter">
            <select aria-label="Research source" value={source} onChange={event => setSource(event.target.value)}>
              <option value={ALL_SOURCES}>All sources ({items.length})</option>
              {sources.map(name => <option key={name} value={name}>{name}</option>)}
            </select>
          </div>

          {/* The two recent groups open; Earlier stays folded. */}
          {groups.map(({ group, items: groupItems }) => (
            <details key={group} className="researchgroup" open={group !== 'Earlier'}>
              <summary>{group} <span className="tabcount">{groupItems.length}</span></summary>
              {groupItems.length ? groupItems.map((item, index) => (
                <div key={index} className="researchitem">
                  <span className="researchsource">{item.source}</span>
                  <span className="researchtext">
                    {/* Links in the text are links; the item's own link is added when the text has none. */}
                    <LinkedText text={item.text} />
                    {item.url && !firstLinkIn(item.text) ? <> <a href={item.url} target="_blank" rel="noopener noreferrer">↗</a></> : null}
                  </span>
                  <span className="researchday">{item.day ?? ''}</span>
                </div>
              )) : <p className="panelempty">Nothing {group === 'Earlier' ? 'older' : group.toLowerCase()}.</p>}
            </details>
          ))}
        </>
      ) : <p className="panelempty">No research saved for this account yet. Ask Scout to research it.</p>}

      <p className="tabsource">Dates stay with their evidence. Scout&apos;s research is its saved record; signals are best_signal.py; Clay is the OB Engine.</p>
    </>
  );
}
